<template>
  <div>
    <vxe-grid
      ref="predictTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      row-id="amzSkuCode"
      cell-class-name="align-top"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :footer-method="() => footerData"
      :seq-config="{ startIndex: 0 }"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      @edit-closed="changeTable"
    >
      <template v-slot:hxJdOrderNo="{ row }">
        <span>单号：{{ row.hxJdOrderNo }}</span>
        <br />
        <span>DC：{{ row.jdDc }}</span>
        <br />
        <span>WH：{{ row.jdWh }}</span>
      </template>
      <template v-slot:originalCtnQty="{ row }">
        <span>整箱：{{ row.originalFclCtnQty }}</span>
        <br />
        <span>尾箱：{{ row.originalTailCtnQty }}</span>
        <br />
        <span>总数：{{ row.originalSubCtnQty }}</span>
      </template>
      <template v-slot:ctnQty="{ row }">
        <span>整箱：{{ row.fclCtnQty }}</span>
        <br />
        <span>尾箱：{{ row.tailCtnQty }}</span>
        <br />
        <span>总数：{{ row.subCtnQty }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format, add } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    loading: { type: Boolean, default: false },
    tablePage: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { typ: String, default: '' },
    highlightCurrentRow: { typ: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns.map((t) => {
        const val = totalColumnValues[t.field]
        return val ? format(val) : ''
      })
      result[1] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    async changeTable() {
      const t_tableData = [...this.tableData]
      this.$emit('changeTable', t_tableData)
    },
    async getTableData() {
      return this.tableData
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
  .vxe-table--render-default .vxe-body--row.row--current {
    background-color: #18c5bd !important;
  }
}
</style>
